import {SettingOutlined} from "@ant-design/icons";
import {Button} from "antd";

export function SettingsButton({type="text", ...rest}) {
	return (
		<Button {...rest} type={type} icon={<SettingOutlined/>}/>
	);
}
